import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { TabsRouter } from '../../components/generic/TabsRouter';
import { ContentLayout } from '../../components/layouts/ContentLayout';
import { BasicSettings } from './BasicSettings';
import { NotificationsSettings } from './NotificationsSettings';
import { SecuritySettings } from './SecuritySettings';

export const Profile = () => {
  const routes = ['basic', 'security', 'notifications'];

  return (
    <ContentLayout
      headerContent={
        <ChakraV3.Heading size='3xl' fontWeight='bold'>
          Profile
        </ChakraV3.Heading>
      }
    >
      <TabsRouter
        variant='subtle'
        orientation='vertical'
        defaultValue={routes[0]}
        size='sm'
        w='full'
        h='full'
        lazyMount
        unmountOnExit
        routes={routes}
        px={6}
        py={2}
      >
        <ChakraV3.Tabs.List w='120px' flexShrink={0}>
          <ChakraV3.Tabs.Trigger value='basic'>Basic</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='security'>Security</ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger value='notifications'>Notifications</ChakraV3.Tabs.Trigger>
        </ChakraV3.Tabs.List>
        <ChakraV3.Tabs.ContentGroup overflowY='auto' h='full' w='full' px={6}>
          <ChakraV3.Tabs.Content value='basic'>
            <BasicSettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='security'>
            <SecuritySettings />
          </ChakraV3.Tabs.Content>
          <ChakraV3.Tabs.Content value='notifications'>
            <NotificationsSettings />
          </ChakraV3.Tabs.Content>
        </ChakraV3.Tabs.ContentGroup>
      </TabsRouter>
    </ContentLayout>
  );
};
